import { Col, Form, Input, InputNumber, Row, Select, Switch } from 'antd';
import { useContext, useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import { SocketContext } from '../../../App';

export default function InternalStatisticsTypeEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    const [internalStatisticsCategoryData, setInternalStatisticsCategoryData] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = "";

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    console.log(res.data);
                    
                    form.setFieldsValue({ internalStatisticsCategoryId: res.data.internalStatisticsCategoryId });
                }
            })
        }
        
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "internalStatisticsCategory",
                apiExtend: 'showList',
                apiVariable: contextData?.currentAreaId
            }).then(res => {
                if (res.success) {
                    setInternalStatisticsCategoryData(res.data);
                }
            })
        }
        fetchData()
    }, [])

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'internalStatisticsType'
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '内部统计小分类'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    initialValues={{ "sortBy": 999 }}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >

                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="内部统计大分类"
                                name="internalStatisticsCategoryId"
                                rules={[{ required: true, message: '请选择内部统计大分类!' }]}>
                                <Select
                                    showSearch
                                    placeholder="内部统计大分类"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {/* {getList.generalEx(internalStatisticsCategoryData, {
                                        itemName: "internalStatisticsCategoryName",
                                        includeNull: false
                                    })} */}
                                    {getList.generalEx(internalStatisticsCategoryData, {
                                        itemName: 'internalStatisticsCategoryName',
                                        setItemNameFun: (item: any) => {
                                            let name = '';
                                            if (item) {
                                                const { area } = item;
                                                if (area) {
                                                    name = `( ${area.areaName} )  `;
                                                }
                                                else {
                                                    name = `( 共用 )  `;
                                                }
                                                name += item.internalStatisticsCategoryName;
                                            }
                                            return name;
                                        }
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="内部统计小分类"
                                name="internalStatisticsTypeName"
                                rules={[{ required: true, message: '请输入内部统计小分类!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}